export const colunasBabyGestacao = (codLojaAtiva) => [
    {
        dataField: "loja",
        text: codLojaAtiva ? "Loja" : "Nível",
        headerAlign: "center",
        align: "center",
        headerStyle: { backgroundColor: "#FFDB8A", color: "#333", fontWeight: "bold" },
    },
    {
        dataField: "vlrAnoAtual",
        text: "Total Vendido",
        headerAlign: "center",
        align: "center",
        headerStyle: { backgroundColor: "#E5E7EB", color: "#333", fontWeight: "bold" },
        formatter: (cell) => parseFloat(cell).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    },
    {
        dataField: "qtdAnoAtual",
        text: "Qtd. Pedidos",
        headerAlign: "center",
        align: "center",
        headerStyle: { backgroundColor: "#E5E7EB", color: "#333", fontWeight: "bold" },
    },
    {
        dataField: "totalClientes",
        text: "Qtd. Clientes",
        headerAlign: "center",
        align: "center",
        headerStyle: { backgroundColor: "#E5E7EB", color: "#333", fontWeight: "bold" },
    },
    {
        dataField: "vlrMedioAnoAtual",
        text: "Ticket Médio",
        headerAlign: "center",
        align: "center",
        headerStyle: { backgroundColor: "#E5E7EB", color: "#333", fontWeight: "bold" },
        formatter: (cell) => parseFloat(cell).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    },
    {
        dataField: "lucro",
        text: "Margem %",
        headerAlign: "center",
        align: "center",
        headerStyle: { backgroundColor: "#E5E7EB", color: "#333", fontWeight: "bold" },
        formatter: (cell) => parseFloat(cell).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "%",
    },
    {
        dataField: "representatividadeAtual",
        text: "Rpr. %",
        headerAlign: "center",
        align: "center",
        headerStyle: { backgroundColor: "#E5E7EB", color: "#333", fontWeight: "bold" },
        formatter: (cell) => parseFloat(cell).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "%",
    },
];